import $ from 'jquery';

$(document).ready(function () {
	

	//STICKY HEADER
	$(window).scroll(function() {
		if ($(this).scrollTop() > 0){
			$('body.fixed-header').addClass('sticky-body');
		}
		else{
			$('body.fixed-header').removeClass('sticky-body');
		}
	});
	
    //STICKY white
	$(window).scroll(function() {
		if ($(this).scrollTop() > 0){
			$('body.fixed-header #whitebox').removeClass('header-inner-white');
		}
		else{
			$('body.fixed-header #whitebox').addClass('header-inner-white');
		}
	});
	
	// $('.sing-up-btn').on('click',function () {
	// 	$('.modal-quick-checkup-box').addClass('active');
	// 	console.log('clicked');
	// });
	
	//MENU CLOSE FUNCTION
    function menu_close(){
       $('.sidebar-wrapper').removeClass('active');
       $('.hamburger-menu-inner').removeClass('change');
       $('.overlay').hide();
    }
	
	
   // ON CLICK change 

	// $('.mobile-btn').on('click', function(){
	// 	$('.btn-hamburger-col').toggleClass('active');
	// 	$('.mobile-btn').toggleClass('active');
	// 	$('.mobile-box').toggleClass('active');
	// });
	
	if ($(window).width() < 992) {
		$('#exampleModal').addClass('modal fade');
	} 
	//HAMBURGER MENU OF USER PANEL
    // $('.hamburger-menu-inner').on('click', function(){
    //     if($(this).hasClass('change'))
    //     {
    //         $('.overlay').hide();
    //         $('.sidebar-wrapper').removeClass('active');
    //         $(this).removeClass('change');
    //     }
    //     else{
    //         $('.overlay').show();
    //         $('.sidebar-wrapper').addClass('active');
    //         $(this).addClass('change');
    //     }
    // });
	 
	$('.buttonbox-btn').on('click', function(){
		$('.buttonbox-btn').toggleClass('active');
		$('.sidebar-product-section').toggleClass('active');
		// $('body').toggleClass('seller_product_list');
		// $('body').removeClass('seller_product_list');
	  });

	  console.log('render custome');

	$('.radio-custom-label').on('click', function(){
		$('.radio-custom-label').removeClass('selected');
		$(this).addClass('selected');
	});

	$('.checkout-accordion-area .accordion-item').on('click', function(){
		console.log('enable');
		$(this).removeClass('disabled-tab');
	});


	//OUTSIDE MENU CLICK,CLOSE MENU
    $(document).on("click", function(event){
        if($('body').prop("clientWidth") < 650) {
            var trigger = $(event.target).attr('class');
            if (trigger == 'overlay') {
              menu_close();
            }
        }
        else if($('body').prop("clientWidth") < 1060) {
            var trigger = $(event.target).attr('class');
            if (trigger == 'overlay') {
              menu_close();
          }        
        }
  	});
	// Notification Enable Disable button
	$('.cb-value').on('click', function(){
		var mainParent = $(this).parent('.toggle-btn');
		if ($(mainParent).find('input.cb-value').is(':checked'))
		{
		  $(mainParent).toggleClass('active');
		} else
		{
		  $(mainParent).toggleClass('active');
		}
	  })
	//DROPDOWN TOGGLE
	//  $('.dropdown-toggle').dropdown();
	 
	//CHANGE EDIT AND CANCEL TEXT
	// $('.account-settings [data-bs-toggle="collapse"]').click(function() {
	// 	$('.accordion-button').text('Edit');
	// 	$(this).toggleClass( "active");
	//   	if ($(this).hasClass("active")) {
	// 		$(this).text("Cancel");
	//   	} else {
	// 		$(this).text("Edit");
	//   	}
	// });


	// seller search Menu
	// $(document).on('click','.js-tab-link',function(){
	// 	var that = $(this);
	// 	var thisSec = $(document).find('#'+ that.attr('href').replace('#',''));
	// 	$.each($(document).find('.seller-search-page'),function(){
	// 		if($(this).hasClass('active')){
	// 			$(this).removeClass('active');
	// 		}
	// 	});
	// 	$.each($(document).find('.js-tab-link'),function(){
	// 		if($(this).hasClass('active')){
	// 			$(this).removeClass('active');
	// 		}
	// 	});
	// 	that.addClass('active');
	// 	thisSec.addClass('active');
	// });
	 
	//DISABLED BUTTON WHENEVER TEXT FIELD IS EMPTY BUTTON 1
	let inputElt = document.getElementById('text_field');
	let btn = document.getElementById('promo_button');
	
	// inputElt.addEventListener("input", function(){
	// 	btn.disabled = (this.value === '');
	// })
	
	//DISABLED BUTTON WHENEVER TEXT FIELD IS EMPTY BUTTON 2
	let button = document.getElementById("promo_button1")
	let input = document.getElementById("text_field1")
	// input.addEventListener("input", function(e) {
	// 	if(input.value.length == 0) {
	// 	button.disabled = true
	//   } else {
	// 	button.disabled = false
	//   }
	// })


});
